const comboboxLocalization = {
  clearLabel: 'Clear selection',
  createLabel: (query: string) => `Create “${query}”`,
  noResults: 'No items found.',
}

export default comboboxLocalization
